export const SEMS_GET = 'SEMS_GET';
export const SEM_ADD = 'SEM_ADD';
export const SEM_EDIT = 'SEM_EDIT';
export const SEM_GET = 'SEM_GET';
export const SEM_DELETE = 'SEM_DELETE';
